<template>
  <fragment>
    <Button v-b-modal.customized-modal-group-criteria class="right-side">Create Criteria Group</Button>
    <b-modal
      id="customized-modal-group-criteria"
      title="Create Criteria Group"
      no-close-on-backdrop
      centered
      size="xl"
      @ok="
        evt => {
          const temp = $emit('onSubmit', this.form);
          // Hide the modal manually
          this.$nextTick(() => {
            this.$bvModal.hide('modal-prevent-closing');
          });
        }
      "
    >
      <b-form-group label="Name" label-for="id-name">
        <b-form-input
          id="id-name"
          placeholder="Memorizing name of the group"
          type="text"
          required
          v-model="form.name"
        />
      </b-form-group>

      <b-form-group label="Choose criteria" label-for="id-select-criteria">
        <v-select inputId="id-select-criteria" v-model="selectedCriteria" :options="options" label="title" />
      </b-form-group>

      <b-table striped hover :fields="criteriaFields" :items="listCriteria" responsive="sm">
        <!-- A virtual column -->
        <template v-slot:cell(id)="data">
          <div class="text-truncate" v-b-tooltip.hover :title="data.item.id" style="width: 80px">
            {{ data.item.id }}
          </div>
        </template>
        <template v-slot:cell(type)="data">
          <span class="text-nowrap">
            {{ data.item.type }}
          </span>
        </template>
      </b-table>
    </b-modal>
  </fragment>
</template>

<script>
import utils from '../utils';
import Button from '@/components/Button';

export default {
  name: 'CreateGroupCriteriaForm',
  components: { Button },
  data() {
    return {
      form: {
        name: null,
        criteriaIds: [],
      },
      listCriteria: [],
      criteriaFields: ['id', { key: 'title', label: 'Title' }, 'explanation', 'type'],
    };
  },
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    selectedCriteria: {
      get() {
        return null;
      },
      set(v) {
        if (v) {
          this.listCriteria.push(v);
          this.form.criteriaIds = this.listCriteria.map(({ id }) => utils.fromGlobalId(id).id);
        }
      },
    },
  },
};
</script>
